import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const fetchNews = (limit = 12) => api.get("/news", { params: { limit } }).then((r) => r.data);
export const fetchCommittee = (group) => api.get("/committee", { params: { group } }).then((r) => r.data);
export const fetchEvents = () => api.get("/events").then((r) => r.data);
export const verifyCode = (code) => api.get("/verify", { params: { code } }).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
